import * as React from "react";
import { forwardRef } from "react";
const SvgSidebarCollapseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.47333 12.4733L5.53333 11.5333L9.06 8.00667L5.53333 4.48L6.47333 3.54L10.4733 7.54C10.7333 7.8 10.7333 8.22 10.4733 8.48L6.47333 12.48V12.4733Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgSidebarCollapseIcon);
export default ForwardRef;
